import { WebApiSettings } from './types';
import { ResponseData } from '../abortable-promise';
import { PanelSettings, Panel } from '../panel';
import { UserAgent } from '../utils';
import { Notification, Queue } from '../notification';
import { Cookies } from '../cookie';
import { Facet } from '../facet';
import { FilterBuilder } from '../filter-builder';

export class WebAPI {
  url: string;
  market: string;
  notify: Notification;
  agent: UserAgent;
  utils = {
    Facet,
    FilterBuilder
  };

  constructor(settings: WebApiSettings) {
    if (!(settings.url || settings.alternativeUrl)) {
      throw new Error('Specify a url in the settings object');
    }

    if (!settings.market) {
      throw new Error('Market must be specified');
    }

    this.url = settings.alternativeUrl ? settings.alternativeUrl : `${settings.url}/api/v2`;
    this.market = settings.market;
    this.notify = new Notification(this.url, this.market, Queue, Cookies);
    this.agent = new UserAgent(window.navigator);

    // Make sure to set customerKey and sessionKey at the start
    Cookies.customerKey();
    Cookies.sessionKey();
  }

  panel(path: string, args: any): Promise<ResponseData> {
    if (!args) args = {};
    if (this.agent.isBot()) args.notify = false;

    const panel = new Panel({
      url: this.url,
      path,
      args: { ...args },
      market: this.market,
      sessionKey: Cookies.sessionKey(),
      customerKey: Cookies.customerKey()
    });

    return panel.createPanelRequest();
  }
}
